export const dispatchOrWrap = (actionObj, dispatch=null) => {
    /*
        Useful so you can write action creators
        that either take dispatch directly (i.e. from useDispatch)
        or that return functions that take dispatch (i.e. in connect())

        i.e.

        const test = dispatch => dispatchOrWrap({ type: 'test' }, dispatch);

        1. with hook:
            const Test = () => {
                dispatch = useDispatch();
                return <button onClick={() => test(dispatch)}>Test</button>
            }

        2. with connect:

            const _Test = ({ test }) => <button onClick={test}>Test</button>;

            Test = connect(undefined, dispatch => ({ test: dispatch(test) }))(_Test);
    */

    if (dispatch) {
        return dispatch(actionObj);
    } else {
        return dispatch => {
            dispatch(actionObj);
        };
    }
};


export const defaultMergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
});
